import { DocumentNode, useApolloClient } from '@apollo/client';
import { FragmentDefinitionNode } from 'graphql';
import { useMemo, useCallback } from 'react';

/**
 * This utility returns the name of a fragment in the cache.
 */
export const getFragmentName = (document: DocumentNode) => {
  const fragment = document.definitions.find(
    d => d.kind === 'FragmentDefinition'
  ) as FragmentDefinitionNode | undefined;

  return fragment?.name?.value;
};

/**
 * This utility abstracts away the boilerplate of apollo cache writing.
 */
export const useApolloCacheUtilities = () => {
  const client = useApolloClient();
  const identityInCache = useCallback(
    (type: string, id: string | number) =>
      client.cache.identify({
        __typename: type,
        id,
      }),
    [client]
  );
  return useMemo(() => {
    return {
      client,
      identityInCache,
    };
  }, [identityInCache, client]);
};
